import Layout from '@/layout'

const TpmRoutePatrolRouter = {
  path: '/tpmRoutePatrol',
  component: Layout,
  redirect: '/tpmRoutePatrol/list',
  name: 'tpmRoutePatrolMenu',
  meta: { title: '路线巡检', icon: 'work_order' },
  children: [
    {
      path: '/tpmRoutePatrol/list',
      component: () => import('@/views/tpmRoutePatrol/index'),
      name: 'tpmRoutePatrolMenuList',
      meta: { title: '路线巡检' }
    },
    {
      path: '/tpmRoutePatrol/detail/:id',
      component: () => import('@/views/tpmRoutePatrol/detail'),
      hidden: true,
      name: 'tpmRoutePatrolMenuDetail',
      meta: { title: '路线巡检详情', activeMenu: '/tpmRoutePatrol/list' }
    }
  ]
}

export default TpmRoutePatrolRouter
